import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_EUROPEAN_UNION_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    doYouHaveAnyOtherTypeOfCoverage: 'false',
    insuranceCarriersName: '',
    address: '',
    cityOrTown: '',
    country: '',
    postalCode: '',
    policyId: '',
    dateTravelArrangementsWereMade: '',
    dateOfInitialPaymentDeposit: '',
    typeOfPolicy: '',
    contact: '',
    phoneNumber: '',
    haveYouFiledAClaimWithTheirOfficeAtThisTime: '',
    nameOfPersonHavingSicknessOrInjury: '',
    hisOrHerDateOfBirth: '',
    isTheClaimTheResultOfASicknessOrInjury: '',
    natureOfSickness: '',
    accidentOfInjury: '',
    dateNature: '',
    placeNature: '',
    pleaseNoteTheirResponse: '',
    whyNot: '',
    // periodOfHospitalizationNature: '',
    fromDateNature: '',
    toDateNature: '',
    endDateNature: '',
    wasThereAnAccidentReportForThisIncident: 'false',
    wasThereAnyPreviousTreatmentForThisCondition: 'false',
    expenseDescriptionOfItems: [],
    dateSicknessOrInjuryBegan: '',
    dateFirstTreated: '',
    nameOfPhysician: '',
    datesOfTreatment: '',
    natureOfInjury: '',
    treatmentDates: [],
  },
  errors: [],
});

const initialEuropeanUnionState = {
  form: {
    areYouACitizenOfTheEuropeanUnion: 'false',
    forEUCitizens: 'false',
    ifYesWasTheEHIC: 'false',
    ifNoPleaseExplain: '',
  },
};

function medicalExpenseStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_EUROPEAN_UNION_STATE:
      return state.mergeDeep(initialEuropeanUnionState);
    // case RESET_TRAVEL_DELAY_STATE:
    //   return state
    //       .setIn(['form', 'descriptionOfItemsForDamaged'], [])
    //       .mergeDeep(initialForBaggageDelayState);
    default:
      return state;
  }
}

export default medicalExpenseStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.MedicalExpenseStep/reducer.js